import { ApiKeysService } from 'data/services/api-keys';
import { ApiKeysServiceInterface } from 'domain/services';
import { makeRemoteCreateApiKey } from 'main/factories/usecases/api-keys/create-api-key';
import { makeRemoteListApiKeys } from 'main/factories/usecases/api-keys/list-api-key';
import { makeRemoteToggleApiKey } from 'main/factories/usecases/api-keys/toggle-api-key';
import { makeRemoteUpdateNameApiKey } from 'main/factories/usecases/api-keys/update-name-api-key';

export const makeApiKeysService = (): ApiKeysServiceInterface => {
  return new ApiKeysService({
    listApiKeys: makeRemoteListApiKeys(),
    createApiKey: makeRemoteCreateApiKey(),
    updateApiKeyName: makeRemoteUpdateNameApiKey(),
    toggleApiKey: makeRemoteToggleApiKey(),
  });
};
